export default __webpack_public_path__ + "static/media/get-e-logo-large.ab0e07db.png";